// Central content + config for Andrews Building Company

export const SITE_URL = "https://andrewsbuildingcompany.com";

export const COMPANY = {
  name: "Andrews Building Company",
  short: "abc",
  tagline: "Industrial & commercial refurbishment specialists — established 1986.",
  established: "1986",
  logo: "/logo-full.png",
  logoOnDark: "/logo-full-white.png",
  logoWhite: "/logo-white.png",
  phone: "01908 211262 / 739507",
  phoneHref: "tel:+441908211262",
  email: "info@andrewsbuilding.com",
  addressLine: "Alphabet House, Bleak Hall, Milton Keynes MK6 1NE",
  registeredAddress: "Alphabet House, Bleak Hall, Milton Keynes MK6 1NE",
  region: "Milton Keynes and South Central England",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Our Story", to: "/our-story" },
  { label: "Our Team", to: "/our-team" },
  { label: "Our Services", to: "/services" },
  { label: "Portfolio", to: "/portfolio" },
  { label: "Contact", to: "/contact" },
];

// Real Andrews Building Company project photography
const P = {
  aylesbury1: "/projects/aylesbury-aerial-1.jpg",
  aylesbury2: "/projects/aylesbury-aerial-2.jpg",
  aylesbury3: "/projects/aylesbury-aerial-3.jpg",
  hayesExt1: "/projects/hayes-ext-1.jpg",
  hayesExt2: "/projects/hayes-ext-2.jpg",
  hayesInt1: "/projects/hayes-interior-1.jpg",
  hayesInt2: "/projects/hayes-interior-2.jpg",
  hayesOffice: "/projects/hayes-office.jpg",
  hayesWashroom: "/projects/hayes-washroom.jpg",
  hayesBeforeExt: "/projects/hayes-before-ext.jpg",
  hayesBefore1: "/projects/hayes-before-1.jpg",
  hayesBefore2: "/projects/hayes-before-2.jpg",
  windsorBefore1: "/projects/windsor-before-1.jpg",
  windsorBefore2: "/projects/windsor-before-2.jpg",
  windsorAfter1: "/projects/windsor-after-1.jpg",
  windsorAfter2: "/projects/windsor-after-2.jpg",
  windsorAfter3: "/projects/windsor-after-3.jpg",
};

export const PROJECT_IMG = P;

// Stock fallbacks for services without dedicated photography
const STOCK = {
  crane: "https://images.unsplash.com/photo-1748956628042-b73331e0b479?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  frame: "https://images.unsplash.com/photo-1777919393704-727d2bf9dd78?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  office: "https://images.unsplash.com/photo-1718220216044-006f43e3a9b1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const IMAGES = {
  hero: "/projects/abc-exterior.jpg",
  exteriorNew: "/projects/abc-exterior.jpg",
  officeNew: "/projects/abc-office.jpg",
  unitNew: "/projects/abc-unit.jpg",
  groundworksNew: "/projects/abc-groundworks.jpg",
  ...P,
  ...STOCK,
};

export const ACCREDITATIONS = [
  "CITB",
  "Constructionline",
  "NIC/EIC",
  "Gas Safe",
  "Sharmans Approved Contractors",
];

export const PROOF_POINTS = [
  { value: "1986", label: "Established" },
  { value: "40+ yrs", label: "In the building industry" },
  { value: "100s", label: "Projects delivered" },
  { value: "35+ yrs", label: "Longest team tenure" },
];

export const SERVICE_OVERVIEW = [
  {
    id: "industrial-refurbishment",
    title: "Industrial Refurbishment",
    blurb: "Full refurbishments for industrial premises — delivered with minimal disruption.",
    image: P.hayesInt1,
  },
  {
    id: "commercial-refurbishment",
    title: "Commercial Refurbishment",
    blurb: "Offices and retail spaces transformed to a high standard, on spec and on time.",
    image: P.hayesOffice,
  },
  {
    id: "dilapidations",
    title: "Dilapidations",
    blurb: "End-of-lease and dilapidation works handled properly, protecting your position.",
    image: P.hayesBeforeExt,
  },
  {
    id: "groundworks-structural",
    title: "Groundworks & Structural Works",
    blurb: "Specialist groundworks and structural repairs by experienced staff.",
    image: STOCK.crane,
  },
];

// Featured services (with imagery)
export const SERVICES = [
  { id: "industrial-refurbishment", title: "Industrial refurbishment", image: P.hayesInt1, desc: "Refurbishment of industrial premises to a high, functional standard — floors, lighting, welfare and finishes." },
  { id: "commercial-refurbishment", title: "Commercial refurbishment (offices & shops)", image: P.hayesOffice, desc: "Modernisation and fit-out of offices, shops and washrooms with minimal disruption to trading." },
  { id: "dilapidations", title: "Dilapidations projects", image: "/projects/abc-unit.jpg", desc: "End-of-lease dilapidation works that reinstate premises and protect commercial positions." },
  { id: "groundworks", title: "Specialist groundworks", image: "/projects/abc-groundworks.jpg", desc: "Groundworks handled by experienced teams — foundations, drainage, hard standings and more." },
  { id: "structural", title: "Specialist structural works", image: STOCK.frame, desc: "Structural alterations and repairs delivered safely and to specification." },
  { id: "office-fit-outs", title: "Office fit-outs", image: "/projects/abc-office.jpg", desc: "Turnkey office fit-outs — partitions, ceilings, finishes and services." },
  { id: "external-decorating", title: "External decorating", image: "/projects/abc-external-decorating.jpg", desc: "Professional external decorating that protects and lifts commercial and industrial buildings." },
  { id: "internal-decorating", title: "Internal decorating", image: STOCK.office, desc: "High-quality internal decorating for offices, retail and industrial interiors." },
  { id: "roof-replacement", title: "Roof replacement & refurbishment", image: P.aylesbury3, desc: "Roof replacement and refurbishment, including profiled and panel systems." },
  { id: "over-cladding", title: "Over-cladding", image: P.windsorAfter1, desc: "Over-cladding to improve appearance, performance and weather-tightness." },
];

// Additional services (listed, no imagery required)
export const SERVICES_OTHER = [
  "Fire door replacements",
  "Commercial gas works",
  "NIC/EIC electrical works",
  "Asbestos removal",
  "Signage supply & installation",
];

export const HOW_WE_WORK = [
  { n: "01", title: "Hands-on management", text: "Directors and managers on site, not hidden behind layers of paperwork." },
  { n: "02", title: "Clear communication", text: "Straight answers and regular updates from people who know the job." },
  { n: "03", title: "Safety & compliance first", text: "Every project run to current safety and compliance standards." },
  { n: "04", title: "Minimal disruption", text: "We work around operational premises to keep you running." },
  { n: "05", title: "On time, on budget", text: "Delivered to spec — the same dependable way we always have." },
];

export const STORY_CHAPTERS = [
  {
    n: "01",
    title: "Founded in 1986",
    text: "Andrew was already involved in construction and grew the business organically through the 80s and 90s. Commercial work grew steadily in the 90s and, for the last ten years, has made up 100% of what we do.",
  },
  {
    n: "02",
    title: "Built on relationships",
    text: "Without advertising, the company has gone from strength to strength — building lasting relationships with clients and surveyors across the industrial sector.",
  },
  {
    n: "03",
    title: "Our own employed team",
    text: "Recruiting specialist trades has enabled work to be carried out by our own employed team, ensuring quality and reliability on every project.",
  },
  {
    n: "04",
    title: "Our own premises in Milton Keynes",
    text: "We work from our own premises at Alphabet House, Bleak Hall, Milton Keynes, and are proud to be a seven-figure business earning its reputation the honest way.",
  },
];

export const TEAM_STATS = [
  { value: "10", label: "Full-time employed team" },
  { value: "~10", label: "Specialist subcontractors/companies" },
  { value: "35+", label: "Years — John Paice, Site Manager" },
];

// Real featured case studies with captioned before/after galleries
export const PROJECTS = {
  windsor: {
    id: "windsor",
    type: "Over-Cladding",
    title: "Office Over-Cladding, Windsor",
    region: "Windsor",
    scope: "Complete external over-cladding of a tired two-storey office block, transforming a weathered brick and render elevation into a clean, modern, weather-tight envelope.",
    challenge: "Working across large, occupied elevations with precise setting-out to achieve a consistent finish and detailing throughout.",
    outcome: "A refreshed, better-performing building with a striking, contemporary appearance — a genuine before-and-after transformation.",
    compare: {
      before: { src: P.windsorBefore1, caption: "Original tired elevation" },
      after: { src: P.windsorAfter1, caption: "New over-clad frontage" },
    },
    before: [
      { src: P.windsorBefore1, caption: "Original tired elevation" },
      { src: P.windsorBefore2, caption: "Weathered brick & render" },
    ],
    after: [
      { src: P.windsorAfter1, caption: "New over-clad frontage" },
      { src: P.windsorAfter2, caption: "Clean roller-shutter bay" },
      { src: P.windsorAfter3, caption: "Modern side elevation" },
    ],
  },
  aylesbury: {
    id: "aylesbury",
    type: "Roof Replacement",
    title: "Industrial Roof Replacement, Aylesbury",
    region: "Aylesbury",
    scope: "Replacement and refurbishment of industrial roof coverings across units on a busy trade estate, including safe access and weather management.",
    challenge: "Maintaining weather-tightness and site safety while working at height over occupied, operational premises.",
    outcome: "Durable, weather-tight roofs delivered safely with no disruption to the businesses trading below.",
    after: [
      { src: P.aylesbury1, caption: "Trade estate overview" },
      { src: P.aylesbury2, caption: "Replaced unit roofs" },
      { src: P.aylesbury3, caption: "New roof, close up" },
    ],
  },
  hayes: {
    id: "hayes",
    type: "Commercial & Industrial Refurbishment",
    title: "Unit Refurbishment, Hayes",
    region: "Hayes",
    scope: "Full strip-out and refurbishment of a commercial unit — from a busy operational workshop to a clean, refitted space with new office fit-out, washrooms, flooring, lighting and decoration.",
    challenge: "Transforming a heavily used working environment into a presentable, high-specification space to a clear programme.",
    outcome: "A bright, modern, ready-to-use facility — offices, washrooms and open industrial space finished to a high standard.",
    compare: {
      before: { src: P.hayesBefore1, caption: "Working garage, pre-refit" },
      after: { src: P.hayesInt1, caption: "Cleared & refinished space" },
    },
    before: [
      { src: P.hayesBeforeExt, caption: "Original unit exterior" },
      { src: P.hayesBefore1, caption: "Working garage, pre-refit" },
      { src: P.hayesBefore2, caption: "Cluttered operational space" },
    ],
    after: [
      { src: P.hayesExt1, caption: "Refurbished exterior" },
      { src: P.hayesInt1, caption: "Cleared industrial space" },
      { src: P.hayesInt2, caption: "Refinished open interior" },
      { src: P.hayesOffice, caption: "New office fit-out" },
      { src: P.hayesWashroom, caption: "New washroom" },
    ],
  },
};

// Portfolio grid tiles (each links to a real project + gallery)
export const PORTFOLIO = [
  { projectId: "windsor", image: P.windsorAfter1, label: "Over-Cladding", region: "Windsor", span: "lg:col-span-2 lg:row-span-2" },
  { projectId: "hayes", image: P.hayesInt1, label: "Refurbishment", region: "Hayes", span: "" },
  { projectId: "aylesbury", image: P.aylesbury2, label: "Roof Replacement", region: "Aylesbury", span: "" },
  { projectId: "hayes", image: P.hayesOffice, label: "Office Fit-Out", region: "Hayes", span: "lg:col-span-2" },
  { projectId: "windsor", image: P.windsorBefore2, label: "Before Over-Cladding", region: "Windsor", span: "" },
  { projectId: "aylesbury", image: P.aylesbury3, label: "Roof Replacement", region: "Aylesbury", span: "" },
  { projectId: "hayes", image: P.hayesBefore1, label: "Before Refurbishment", region: "Hayes", span: "" },
  { projectId: "hayes", image: P.hayesWashroom, label: "Washroom Refurbishment", region: "Hayes", span: "" },
];

export const SEO = {
  "/": {
    title: "Andrews Building Company | Industrial & Commercial Refurbishment, Milton Keynes",
    description: "Industrial & commercial refurbishment specialists established 1986. Refurbishment, dilapidations, groundworks and structural works across Milton Keynes and South Central England.",
  },
  "/our-story": {
    title: "Our Story | Andrews Building Company",
    description: "Founded in 1986 and grown organically without advertising. A Milton Keynes refurbishment company built on quality, reliability and long-standing relationships.",
  },
  "/our-team": {
    title: "Our Team | Andrews Building Company",
    description: "A hand-picked Milton Keynes team with exceptional staff retention — including Site Manager John Paice, with us for over 30 years.",
  },
  "/services": {
    title: "Our Services | Industrial & Commercial Refurbishment, Dilapidations",
    description: "Industrial and commercial refurbishment, dilapidations, groundworks, structural works, roofing, over-cladding, decorating, fire doors, gas, electrical and more.",
  },
  "/portfolio": {
    title: "Project Portfolio | Andrews Building Company",
    description: "Real industrial and commercial projects — over-cladding in Windsor, roof replacement in Aylesbury and unit refurbishment in Hayes, with before-and-after results.",
  },
  "/contact": {
    title: "Contact Us | Andrews Building Company, Milton Keynes",
    description: "Request a call back from Andrews Building Company. Serving industrial and commercial clients across Milton Keynes and South Central England.",
  },
  "/privacy-policy": { title: "Privacy Policy | Andrews Building Company", description: "How Andrews Building Company collects, uses and protects your data under UK GDPR and the Data Protection Act 2018." },
  "/website-terms": { title: "Website Terms & Conditions | Andrews Building Company", description: "Terms and conditions for the use of the Andrews Building Company website." },
  "/cookie-policy": { title: "Cookie Policy | Andrews Building Company", description: "How Andrews Building Company uses cookies and how you can manage your preferences." },
  "/accessibility": { title: "Accessibility | Andrews Building Company", description: "Our commitment to an accessible website for all users." },
  "/sitemap": { title: "Sitemap | Andrews Building Company", description: "A list of all pages on the Andrews Building Company website." },
};
